import { RepositoryFactory } from "@/repositories/RepositoryFactory";

const TabuleoSubscriptionsRepository = RepositoryFactory.get(
  "tabuleoSubscriptions",
);

const state = {
  subscriptions: [],
  subscription: {},
};

const getters = {
  getEstablishments: () => state.establishments,
  getSubscription: () => state.subscription,
};

const actions = {
  getSubscriptions({ commit, dispatch, state }, params = {}) {
    dispatch("loadings/enableLoadings", {}, { root: true });

    TabuleoSubscriptionsRepository.getSubscriptions(params)
      .then((response) => {
        const subscriptions = response.data.results;
        commit("SAVE_SUBSCRIPTIONS", subscriptions);
      })
      .catch(() => {
        dispatch(
          "notifications/addError",
          {
            message: state.$t(
              `message.notifications.tabuleoSubscription.getSubscriptionsError`,
            ),
          },
          { root: true },
        );
      })
      .finally(() => {
        dispatch("loadings/disableLoadings", {}, { root: true });
      });
  },
  getSubscription({ commit, dispatch, state }, id) {
    dispatch("loadings/enableLoadings", {}, { root: true });

    return TabuleoSubscriptionsRepository.getSubscription(id)
      .then((response) => {
        const subscription = response.data.results;
        commit("SAVE_SUBSCRIPTION", subscription);
      })
      .catch(() => {
        dispatch(
          "notifications/addError",
          {
            message: state.$t(
              `message.notifications.tabuleoSubscription.getSubscriptionError`,
            ),
          },
          { root: true },
        );
      })
      .finally(() => {
        dispatch("loadings/disableLoadings", {}, { root: true });
      });
  },
};

const mutations = {
  SAVE_SUBSCRIPTIONS(state, subscriptions) {
    state.subscriptions = subscriptions;
  },
  SAVE_SUBSCRIPTION(state, subscription) {
    state.subscription = subscription;
  },
};

export default {
  namespaced: true,
  getters,
  state,
  actions,
  mutations,
};
